// NIM SDK 的 appkey 配置
export const NIM_APP_KEY = '3e215d27b6a6a9e27dad7ef36dd5b65c'
// NIM 的日志输出等级
export const NIM_DEBUG_LEVEL = 'debug'
// NIM 的 LBS 负载均衡服务地址
export const NIM_LBS_URLS = ['https://lbs.netease.im/lbs/webconf.jsp']
// NIM 的 兜底 TCP 连接地址
export const NIM_LINK_URL = 'weblink.netease.im'
